import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Structure from './pages';
import { theme } from './theme';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Structure />
    </MuiThemeProvider>
  );
}

export default App;
